import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, createSlots as _createSlots, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "k-item-card__image-container relative-position" }
const _hoisted_2 = {
  key: 0,
  class: "k-item-card__color rounded-circle"
}
const _hoisted_3 = { class: "fs-13px fw-500 text-dark-bg-20" }
const _hoisted_4 = {
  key: 0,
  class: "k-item-card__pause-container transition absolute flex"
}
const _hoisted_5 = { class: "row items-center gap-xs no-wrap" }
const _hoisted_6 = { class: "fs-11px fw-500 text-cool-gray-100" }
const _hoisted_7 = {
  key: 1,
  class: "k-item-card__callout bg-white rounded-circle transition absolute q-pa-xs flex flex-center"
}

import defaultImage from 'src/shared/static/images/card-placeholder.jpg'
import { ref, computed } from 'vue'

interface IProps {
  image?: string
  description?: string
  price?: string
  icon?: string
  color?: string
  itemNumber?: string
  paused?: boolean
  text?: Record<PropertyKey, unknown>
  size?: 'lg' | 'md' | 'sm'
  imageless?: boolean
  callout?: Record<PropertyKey, unknown> | null
}

interface IEmits {
  (event: 'select', data: string): void
  (event: 'action', data: void): void
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'KItemCard' },
  __name: 'KItemCard',
  props: {
    image: { default: '' },
    description: { default: '' },
    price: { default: '' },
    icon: { default: '' },
    color: { default: '' },
    itemNumber: { default: '' },
    paused: { type: Boolean, default: false },
    text: { default: () => ({}) },
    size: { default: 'md' },
    imageless: { type: Boolean, default: false },
    callout: { default: null }
  },
  emits: ["select", "action"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "v79cb166a": (_ctx.color)
}))


const props = __props
const emit = __emit

const sizeRef = ref({
  sm: {
    card: {
      maxWidth: '162px',
      minHeight: '196px',
    },
    image: {
      width: '152px',
      height: '100px',
    },
    circleIcon: {
      width: '32px',
      height: '32px',
    },
    description: 'fs-13px',
    price: 'fs-13px',
    button: '32px',
  },
  md: {
    card: {
      maxWidth: '188px',
      minHeight: '228px',
    },
    image: {
      width: '178px',
      height: '124px',
    },
    circleIcon: {
      width: '32px',
      height: '32px',
    },
    description: 'fs-15px',
    price: 'fs-15px',
    button: '32px',
  },
  lg: {
    card: {
      maxWidth: '226px',
      minHeight: '270px',
    },
    image: {
      width: '216px',
      height: '150px',
    },
    circleIcon: {
      width: '32px',
      height: '32px',
    },
    description: 'fs-15px',
    price: 'fs-15px',
    button: '32px',
  },
})

const imagelessSizeRef = ref({
  sm: {
    card: {
      maxWidth: '162px',
      maxHeight: '128px',
    },
    image: {
      width: '152px',
      height: '0',
    },
    circleIcon: sizeRef.value.sm.circleIcon,
    description: sizeRef.value.sm.description,
    price: sizeRef.value.sm.price,
    button: sizeRef.value.sm.button,
  },
  md: {
    card: {
      maxWidth: '188px',
      minHeight: '128px',
    },
    image: {
      width: '178px',
      height: '0',
    },
    circleIcon: sizeRef.value.md.circleIcon,
    description: sizeRef.value.md.description,
    price: sizeRef.value.md.price,
    button: sizeRef.value.md.button,
  },
  lg: {
    card: {
      maxWidth: '226px',
      minHeight: '128px',
    },
    image: {
      width: '216px',
      height: '0',
    },
    circleIcon: sizeRef.value.lg.circleIcon,
    description: sizeRef.value.lg.description,
    price: sizeRef.value.lg.price,
    button: sizeRef.value.lg.button,
  },
})

const containerSize = computed(() => {
  if (props.imageless) `k-item-card--imageless-size-${props.size}`
  return `k-item-card--size-${props.size}`
})

const sizeRelatedStyles = computed(() => {
  if (props.imageless) return imagelessSizeRef.value[props.size]
  else return sizeRef.value[props.size]
})

const onItemCardClicked = () => {
  if (!props.paused) emit('select', props.itemNumber)
}

return (_ctx: any,_cache: any) => {
  const _component_q_img = _resolveComponent("q-img")!
  const _component_k_icon = _resolveComponent("k-icon")!
  const _component_k_badge = _resolveComponent("k-badge")!
  const _component_k_callout = _resolveComponent("k-callout")!
  const _component_k_circle_icon = _resolveComponent("k-circle-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["k-item-card rounded-16 q-pa-xs bg-white-shadow shadow-1 full-width column gap-xs items-center justify-between transition cursor-pointer", {
      'k-item-card--paused cursor-not-allowed': __props.paused,
      'k-item-card--imageless': __props.imageless,
      [containerSize.value]: containerSize.value,
    }]),
    onClick: onItemCardClicked
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_q_img, {
        src: __props.image,
        "placeholder-src": _unref(defaultImage),
        fit: "cover",
        width: sizeRelatedStyles.value.image.width,
        height: sizeRelatedStyles.value.image.height,
        class: _normalizeClass(["k-item-card__image rounded-12 transition", { 'k-item-card__image--paused': __props.paused }])
      }, null, 8 /* PROPS */, ["src", "placeholder-src", "width", "height", "class"]),
      _createElementVNode("div", {
        class: _normalizeClass(["k-item-card__item-info row items-center no-wrap gap-xs q-py-xs rounded-16 transition absolute", __props.color.length ? 'q-pl-xs q-pr-sm' : 'q-px-sm'])
      }, [
        (__props.color.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2))
          : _createCommentVNode("v-if", true),
        _createElementVNode("span", _hoisted_3, _toDisplayString(__props.itemNumber), 1 /* TEXT */)
      ], 2 /* CLASS */),
      (__props.paused)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_k_badge, {
              "border-color": "caution-70",
              color: "white",
              hoverless: "",
              class: "k-item-card__pause-badge"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_k_icon, {
                    name: "pause",
                    color: "caution-100",
                    size: "16px"
                  }),
                  _createElementVNode("span", _hoisted_6, _toDisplayString(__props.text?.paused ?? 'Paused'), 1 /* TEXT */)
                ])
              ]),
              _: 1 /* STABLE */
            })
          ]))
        : _createCommentVNode("v-if", true),
      (__props.callout && !__props.paused)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_k_callout, _normalizeProps(_guardReactiveProps(__props.callout)), null, 16 /* FULL_PROPS */)
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("span", {
      class: _normalizeClass(["k-item-card__name text-center fw-500 text-cool-gray-100 q-px-xs ellipsis-2-lines", [sizeRelatedStyles.value.description, __props.paused ? 'text-cool-gray-70' : 'text-cool-gray-100']])
    }, _toDisplayString(__props.description), 3 /* TEXT, CLASS */),
    _createElementVNode("div", {
      class: _normalizeClass(["k-item-card__price-container rounded-12 q-pa-xs bg-off-white-10 row items-center full-width relative-position", [__props.size === 'sm' ? 'justify-center' : 'justify-end']])
    }, [
      _createElementVNode("span", {
        class: _normalizeClass(["k-item-card__price absolute transition fw-600 text-cool-gray-100", [
          { 'has-count': __props.size !== 'sm' },
          sizeRelatedStyles.value.price,
          __props.paused ? 'text-cool-gray-70' : 'text-cool-gray-100',
        ]])
      }, _toDisplayString(__props.price), 3 /* TEXT, CLASS */),
      (__props.size !== 'sm')
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "row justify-center items-center rounded-circle",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('action')), ["stop"]))
          }, [
            _createVNode(_component_k_circle_icon, {
              name: __props.icon,
              class: "cursor-pointer",
              color: "cool-gray-70",
              background: "white",
              "is-hover": "",
              size: "20px"
            }, _createSlots({ _: 2 /* DYNAMIC */ }, [
              (_ctx.$slots['action'])
                ? {
                    name: "action",
                    fn: _withCtx(() => [
                      _renderSlot(_ctx.$slots, "action")
                    ]),
                    key: "0"
                  }
                : undefined
            ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["name"])
          ]))
        : _createCommentVNode("v-if", true)
    ], 2 /* CLASS */)
  ], 2 /* CLASS */))
}
}

})